import { render, staticRenderFns } from "./RemarkRecord.vue?vue&type=template&id=3965f0da&scoped=true"
import script from "./RemarkRecord.vue?vue&type=script&lang=js"
export * from "./RemarkRecord.vue?vue&type=script&lang=js"
import style0 from "./RemarkRecord.vue?vue&type=style&index=0&id=3965f0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965f0da",
  null
  
)

export default component.exports